import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import {debounceTime, distinctUntilChanged, map, switchMap} from 'rxjs/operators';

// MODELOS

// RUTAS

// COMPONENTES

// SERVICIOS
import { ParamsService, ReportsService, ItemService, AlertService, AuthenticationService, PermsService, CompanyService, } from '../../../services/index';
import {ItemModelSearch} from "../../../models/i-item";
import {ParamsSearch} from "../../../models/params";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {SearchModalComponent} from "../../../components/shared/search-modal/search-modal.component";
import { ITypeaheadSettings } from 'src/app/models/company';

// PIPES

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  inventoryReport: FormGroup;
  viewParamTitles: any [] = []; // llena la lista con los titulos de las paginas parametrizados
  title: string; // titulo de la vista
  currentUser: any; // variable para almacenar el usuario actual
  currentUserSubscription: Subscription; // suscripcion para obtener el usuario actual
  permisos: boolean  = true;
  typeaheadSettings: ITypeaheadSettings;

  constructor( 
    private fbs: FormBuilder,
    private rService: ReportsService,
    private paramsService: ParamsService,
    private sPerm: PermsService,
    private authenticationService: AuthenticationService,
    private itemService: ItemService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private companyService: CompanyService) 
  {
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  ngOnInit() {
	this.checkPermits();
    this.GetParamsViewList();
    this.GetTypeaheadSettings();
    this.inventoryReport = this.fbs.group({
      Articulo: [''] ,
      Marca: [''],
      Grupo: [''],
      subGrupo: [''],
    });
  }

  // chequea que se tengan los permisos para acceder a la pagina
  checkPermits(){

	  this.sPerm.getPerms(this.currentUser.userId).subscribe((data: any) => {
		  this.blockUI.stop();
		  if (data.result) {
			// console.log(data);
			let permListtable: any = data.perms;
			data.perms.forEach(Perm => {
				if(Perm.Name==="V_Inven"){
					this.permisos = Perm.Active;
				}
			});

		  } else {
			this.permisos = false;
		  }
		}, error => {
		  this.permisos = false;
		  this.blockUI.stop();
		});
	// console.log(this.permisos);
  }

  /**
   * Searches for an item code based on the provided text.
   *
   * @param text$ An observable that emits the search text.
   * @returns An observable that emits search results.
   */
  searchItemCode = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => this.itemService.GetItemsSearch(value, 1, this.typeaheadSettings.ItemsCounts,'inventory')),
      map(term => term.ItemList.map(item => item.FilterUpperCase))
  )


// funcion que llama al servicio que envia la informacion al api para procesar el reporte
// no lleva parametros
  printInventory() {
    this.blockUI.start('Generando la impresión...'); // Start blocking

    let Articulo = '';
    let Marca = '';
    let Grupo = '';
    let subGrupo = '';

    Articulo =  this.inventoryReport.controls.Articulo.value.split(' COD. ')[0];
    Grupo = this.inventoryReport.controls.Grupo.value;
    Marca = this.inventoryReport.controls.Marca.value;

    const PrintInventory = {
      'Articulo': Articulo,
      'Marca': Marca,
      'Grupo': Grupo,
      'subGrupo': subGrupo
    };

    this.rService.printInventory(PrintInventory)
    .subscribe( (data: any) => {
      this.blockUI.stop(); // Stop blocking
      var fileBase64 = atob(data);
      var length = fileBase64.length;
      var arrayBuffer = new ArrayBuffer(length);
      var uintArray = new Uint8Array(arrayBuffer);
      for (var i = 0; i < length; i++) {
        uintArray[i] = fileBase64.charCodeAt(i);
        }
      var tab = window.open();
      var pdfFile = new Blob([uintArray], { type: 'application/pdf'});
      var fileUrl = URL.createObjectURL(pdfFile);
      tab.location.href = fileUrl;
    }, (error: any) => {
      this.blockUI.stop(); // Stop blocking
      this.alertService.errorInfoAlert(`Error al intentar conectar con el servidor, Error: ${error} `);
    });
  }

  // llena los campos de la tabla de items con los campos parametriados
  GetParamsViewList() {
    this.paramsService.getParasmView()
    .subscribe((data: any) => {
      this.blockUI.stop();
      if (data.result) {
        this.viewParamTitles = data.Params.filter( param => {
          return param.type === 6;
        });
        this.ChargeParamstoView();
      } else {
        this.alertService.errorAlert('Error al cargar los parámetros de la pagina - ' + data. errorInfo.Message);
      }
    }, error => {
      this.blockUI.stop();
      this.alertService.errorInfoAlert(`Error al intentar conectar con el servidor, Error: ${error}`);
    });
  }

     // Carga los datos parametrizados en las variables
     ChargeParamstoView() {
      // parametrizacion del titulo
      let obj = this.viewParamTitles.filter( param => {
        return  param.Name === 'T_inventory';
      });
      this.title = obj[0].Text;
    }
  /**
   * Opens a search modal.
   */
  RiseSearchModal():void {
    let modalOption: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'Modal-Xl',
      centered: true
    };

    let modalSearchItems = this.modalService.open(SearchModalComponent, modalOption);
    modalSearchItems.componentInstance.title = 'Busqueda de articulos';
    modalSearchItems.componentInstance.columns = [ 'ItemCode','ItemName', 'OnHand'];
    modalSearchItems.componentInstance.columnsName = ['Código','Nombre', 'Disponible'];
    modalSearchItems.componentInstance.SearchData =  this.SearchItem;
    modalSearchItems.componentInstance.selectRecord.subscribe((item) => {
      this.SelectRecordItem(item);
    });
  }

  /**
   * Searches for items based on the provided search parameters.
   *
   * @param _data The search parameters.
   * @returns An observable that emits an array of ItemModelSearch objects.
   */
  SearchItem= (_data: ParamsSearch):Observable<ItemModelSearch[]> => {
    return this.itemService.GetItemsSearch(_data.SearchValue,_data.Page,_data.PageRecords,'inventory').
    pipe(map(result => result.ItemList));
  }

  SelectRecordItem(item: ItemModelSearch) {
    if (item != null) {
      this.inventoryReport.controls['Articulo'].setValue(item.FilterUpperCase);
    }
  }

  /**
   * Fetches the typeahead configuration settings from the server.
   * If the response is successful, assigns the settings to the local `typeaheadSettings` property.
   * If an error occurs during the request, an error alert is shown to the user.
   */
  GetTypeaheadSettings(){
    this.companyService.GetTypeaheadSettings().subscribe(typeaheadResponse => {
      if(typeaheadResponse.result) {
        this.typeaheadSettings = typeaheadResponse.TypeaheadSettings;
      }
    }, error => {
      this.alertService.errorInfoAlert(`Error al intentar conectar con el servidor, Error: ${error}`);
    })
  }
}
